<template>
  <div id="app" style="height: 100%;position: static;">
    <el-container>
      <el-header style=" color: black; text-align: center; line-height: 60px;font-size: 25px;">
        大健康项目钢筋经济效益看板
      </el-header>
      <!-- 添加横向导航栏 -->
      <el-menu mode="horizontal" router="true" default-active="/GangJin/GangJinGuanLi">
        <el-menu-item index="/GangJin/GangJinGuanLi">钢筋管理</el-menu-item>
        <el-menu-item index="/GangJin/GangJinPanDian">钢筋盘点</el-menu-item>
        <el-menu-item index="/GangJin/GangJinTaiZhang">钢筋台账</el-menu-item>
        <el-menu-item index="/GangJin/GangJinJinDu">钢筋进度</el-menu-item>
        <!-- <el-menu-item index="/GangJin/QuYuHuaFen">区域划分</el-menu-item> -->
        <el-menu-item index="/GangJin/XianChangWenTi">现场问题</el-menu-item>
        <el-menu-item index="/GangJin/ZhiShiKu">知识库</el-menu-item>
      </el-menu>
      <!-- 添加Tab控件 -->
      <div class="tab-container">
        <router-view />
      </div>
    </el-container>
  </div>
</template>
<style scoped>
.el-menu {
  width: 100%;
}
.tab-container{
  width: 100%;
  overflow: auto; /* 添加滚动条，防止内容过多 */
}
</style>

<script>
export default {
  data() {
    return {
      result: "",
      user: "空",
      messagenumber: "",
      WorkReportList: []
    };
  },
  methods: {
    share: function () {
      alert(1);
    },
  },
  created() {
    //获取用户信息
    this.$router.push('/GangJin/GangJinGuanLi');
  }
};
</script>